<template>
<div>
  <div  @click="select($event, data)"  v-bind ='[{id:data.id}]' :class="{'page_list_row-selected': data.add_info.selected}"   class="page_list_row clearfloat selectable"   >
  <div @click="fullInf()" class="page_photo"><img     v-bind ='{src:data.photo_100}'    />   </div>
  <div class="gpage_info selectable">
  <div class="glabeled_name selectable"  > <a v-bind ='{href:data.url}' target="_blank"  style="text-decoration:none; color:#42648b;">  <span >{{data.first_name.substring( 28,-1)}}</span> <span > {{data.last_name.substring( 28,-1)}}</span>   </a>  <span style="color:gray" v-if="data.cat_name != 'Общий список' && data.cat_name.length " > #{{data.cat_name}}  </span> </div>
  <div class="glabeled selectable" > Подписчики: {{data.followers}}     <span v-if="data.activiti > 0 " style="color:green ; font-size:1.2em" > +{{data.activiti}} </span> </div>
  <div class="glabeled selectable" > Друзья: {{data.friends}}  </div>


  </div>

<div class="gfunctions selectable">

<div   style="float:right">

<v-tooltip bottom   open-delay="1000" close-delay="1" max-width="200"   >
<v-icon  @click="checker(data )" slot="activator"   medium    >mdi-update</v-icon>
<span>Получить список новых подписчиков</span>
</v-tooltip>

<v-tooltip bottom   open-delay="1000" close-delay="1"  max-width="200"   >
  <v-icon @click="history(data)" slot="activator"    medium    >mdi-database-search</v-icon>
  <span>Список новых подписчиков и отписавшихся за все обновления активности</span>
</v-tooltip>


  <v-tooltip bottom   open-delay="1000" close-delay="1" max-width="200"   >
    <v-icon slot="activator" @click="remove(data)"    medium    >mdi-delete</v-icon>
    <span>Удалить страницу из списка активновсти</span>
 </v-tooltip>

   </div>
 </div>


  </div>




</div>
</template>




<script>
import axios from 'axios'
export default {

props: ['pages','data','modals'],
 data: function(){
  return {
    ui:{
      options: false
    },
  }
},
methods: {

clearData(data){
  data.selector = false
  data.foundIds = []
  data.displayIds = []
  data.selectedIds = []
  data.offset = 0
  return data
},




  remove: function(data ){
   console.log(data)
     this.pages.deleteId = data
     this.pages.selected.push(data)
    this.pages.modals.deletePages = true
 },

 checker: function (data){
   console.log(data)
   this.pages.checkList = []
   this.pages.checkList.push(data.id)
   this.pages.modals.checkPages = true
 },

 select: function(event,data){

   let classes = event.target.className.split(' ')
    if(classes.indexOf('selectable') !== -1){
      data.add_info.selected = !data.add_info.selected
       if(data.add_info.selected  ){

         this.pages.selected.push(data)

       } else   this.pages.selected.splice(this.pages.selected.indexOf(data),1)



  }


 },

history:function(data){
 this.pages.modals.history = true
  this.pages.history.historyId  = data.id
 this.clearData(this.pages.history.followers.foundData)
 this.clearData(this.pages.history.followers_out.foundData)
 this.clearData(this.pages.history.friends.foundData)
 this.clearData(this.pages.history.friends_out.foundData)

  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_history.php', {
       method: 'POST',
       data: {id: data.id}
     }).then(response => {
         console.log(response.data)
           if(response.data.followers_new.length > 0) {this.pages.history.followers.foundData.foundIds =  response.data.followers_new   }
           if(response.data.followers_new_out.length > 0) {this.pages.history.followers_out.foundData.foundIds =  response.data.followers_new_out   }
           if(response.data.friends_new.length > 0) {this.pages.history.friends.foundData.foundIds =  response.data.friends_new   }
           if(response.data.friends_new_out.length > 0) {this.pages.history.friends_out.foundData.foundIds =  response.data.friends_new_out  }

     })



},



}
}
</script>

<style>


</style>
